// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"28":"data-entry","882":"confirm-data"}[chunkId] + "." + {"28":"9c768fd5","882":"643d9a5d"}[chunkId] + ".css";
};